import { Stack } from '@mui/material';
import { Modal, TextField } from 'melp-design/components';
import { FC } from 'react';
import { Controller, SubmitHandler, useForm } from 'react-hook-form-latest';
import { useTranslation } from 'react-i18next';
import { useEditCustomCategoryValue } from 'store/custom-categories';
import { ModalProps } from 'store/modal';
import { usePredefinedToasts } from 'utils/Toast';

interface Values {
  name: string;
}

interface Props extends ModalProps {
  categoryId: string;
  valueId: string;
  initialValues: Values;
}

export const EditCustomCategoryValueModal: FC<Props> = ({
  closeModal,
  categoryId,
  valueId,
  initialValues,
}) => {
  const { t } = useTranslation();
  const predefinedToasts = usePredefinedToasts();

  const { control, handleSubmit } = useForm<Values>({
    defaultValues: initialValues,
  });

  const { mutate: editValue, isLoading } = useEditCustomCategoryValue();

  const onSubmit: SubmitHandler<Values> = (values) => {
    editValue(
      {
        categoryId,
        valueId,
        data: {
          name: values.name,
        },
      },
      {
        onSuccess: () => {
          closeModal();
          predefinedToasts.success.updated();
        },
      },
    );
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Modal.Content
        title={t('common.edit')}
        actions={[
          {
            variant: 'neutral-outline',
            onClick: () => closeModal({ action: 'CLOSE' }),
            label: t('common.cancel'),
          },
          {
            variant: 'primary',
            label: t('common.confirm'),
            type: 'submit',
            disabled: isLoading,
          },
        ]}
      >
        <Stack gap={2}>
          <Controller
            name="name"
            control={control}
            render={({ field: { name, value, onChange, ref } }) => {
              return (
                <TextField
                  placeholder={t('common.name')}
                  name={name}
                  value={value}
                  onChange={onChange}
                  required
                  ref={ref}
                />
              );
            }}
          />
        </Stack>
      </Modal.Content>
    </form>
  );
};
